import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shell } from '../components/Shell';
import { useAuth } from '../lib/auth';

export function AuthCallbackPage() {
  const { completeSignIn } = useAuth();
  const [status, setStatus] = useState<'pending' | 'error'>('pending');
  const [message, setMessage] = useState('Signing you in…');
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const result = await completeSignIn();
      if (result.ok) {
        navigate('/onboarding/site', { replace: true });
      } else {
        setStatus('error');
        setMessage(result.error);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Shell centerLabel="Signing in…">
      <section className="border-b" style={{ borderColor: 'var(--rule)' }}>
        <div className="max-w-[640px] mx-auto px-6 md:px-14 py-24 text-center">
          <h1 className="font-medium mb-3" style={{ fontSize: 'clamp(24px, 3vw, 36px)', lineHeight: 1.05, letterSpacing: '-0.025em' }}>
            {status === 'pending' ? 'Verifying your link…' : 'Sign-in failed.'}
          </h1>
          <p className="text-[14px] leading-[1.55]" style={{ color: status === 'error' ? 'var(--flag)' : 'rgba(13,11,31,0.7)' }}>
            {message}
          </p>
          {status === 'error' && (
            <a href="/signup" className="btn mt-6 inline-flex">
              <span>Request a new link</span> <span className="slash">/</span>
            </a>
          )}
        </div>
      </section>
    </Shell>
  );
}
